export default __webpack_public_path__ + "static/media/logo-go.da516556.svg";